// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__1IPb3","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__22GP_"};